import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import InstitutionSettings from './InstitutionSettings';
import ProctorGroups from './ProctorGroups';
import UserSettings from './UserSettings';

const Settings = observer(class Settings extends React.Component {
  componentWillMount() {
    this.state = {
      pageContent: null
    }

    // Determine which settings page to show
    if(this.props.content === 'Institution') {
      this.setState({
        pageContent: <InstitutionSettings {...this.props} />
      });
    } else if(this.props.content === 'ProctorGroups') {
      this.setState({
        pageContent: <ProctorGroups {...this.props} />
      });
    } else {
      this.setState({
        pageContent: <UserSettings {...this.props} />
      });
    }
  }

  render() {
    const { translation } = this.props;

    return(
      <main tabIndex="0" id="main-content" className="page">
        <header className="page__header">
          <div className="wrap">
            <h1 className="page__title">{translation.page_title}</h1>
          </div>
        </header>

        {this.state.pageContent}
      </main>
    )
  }
})

export default translate('Settings')(Settings);


// WEBPACK FOOTER //
// ./src/app/components/Settings/Settings.js